module.exports = __webpack_public_path__ + "img/profile-photo.b41d300c.svg";